import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

import { ref, computed, inject } from 'vue'
import { useRouter } from 'vue-router'
import { groupGames } from '@/api/game'
import { playClickSound } from "@/utils/media";
import StatusPopup from '@/components/common/statusPopup.vue'
import { useGameStore } from '@/stores/games'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useUserStore } from '@/stores/user'
import GamePopupOne from '@/themes/themeOne/game/gamePopup.vue';
import GamePopupTwo from '@/themes/themeTwo/game/gamePopup.vue';
import GamePopupThree from '@/themes/themeThree/game/gamePopup.vue';
import { GameData, GameItem, PAGE_SIZE } from './supportScript';
import { useThemeStore } from '@/stores/theme';


export default /*@__PURE__*/_defineComponent({
  __name: 'gamePopup',
  emits: ['resetSelectedGroup', 'goToProfile'],
  setup(__props, { expose: __expose, emit: __emit }) {

const router = useRouter()
const gameStore = useGameStore()
const userStore = useUserStore()
const themeStore = useThemeStore()

const isSuccess = ref(false)
const statusRef = ref()
const loadingRef = ref()
const toastContent = ref('')
const pageNumber = ref(1)

const show = ref(false)
const gameCount = ref(0)
const loadedGameCount = ref(0)
const showLoadMore = ref(true)
const showPopover = ref(false);
const groupList = computed(() =>
    gameStore.groupList.map((item: any) => ({
        id: item.id,
        icon: item.customIcon,
        name: item.name,
        groupType: item.groupType
    }))
)
const activeItem = ref(groupList.value[0] ? groupList.value[0].id : 0)
const gameList = ref<GameItem[]>([])
const favoriteGameList = computed(() => gameStore.groupList[1].games)
const loading = ref(false)
const groupID = ref()
const groupType = ref('')
const balance = computed(() => userStore.balance)
const mainHeader = ref<{ url: string; display: boolean }>({ url: '', display: true })
const depositButon = ref({
    colorCode: '',
    display: false,
    redirectUrl: ''
})
const profileButtonData = ref({
    url: '',
    display: false,
    redirectUrl: ''
})

const dataSet = computed<GameData>(() => ({
    show: show.value,
    showLoadMore: showLoadMore.value,
    showPopover: showPopover.value,
    groupList: groupList.value,
    activeItem: activeItem.value,
    gameList: gameList.value,
    loading: loading.value,
    balance: balance.value,
    mainHeader: mainHeader.value,
    depositButon: depositButon.value,
    profileButtonData: profileButtonData.value,
    gameCount: gameCount.value
}))

const emits = __emit
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')

const open = (data: any) => {
    const URL = localStorage.getItem('componetList')

    if (URL) {
        try {
            const componentList = JSON.parse(URL)
            const headerComponent = componentList.find(
                (item: any) => item.component_name === 'header'
            )
            mainHeader.value = headerComponent.appIcon
            depositButon.value = headerComponent.depositButton
            profileButtonData.value = headerComponent.profileButton
        } catch (error) {
            console.error("Failed to parse componetList from localStorage", error)
        }
    }
    loadingRef.value.open()
    show.value = true
    groupID.value = data.id
    groupType.value = data.groupType
    activeItem.value = data.id
    if (data.id == 'fav') {
        gameList.value = favoriteGameList.value
        gameCount.value = gameList.value.length
        showLoadMore.value = false
        loadingRef.value.close()
    } else {
        getGameGroupList()
    }

}

const close = () => {
    show.value = false
    gameList.value = []
    pageNumber.value = 1
    gameStore.getGameGroupListData()
    loadedGameCount.value = 0;
    emits('resetSelectedGroup')
}
const goToProfile = () => {
    emits('goToProfile')
}
const selectGroup = (item: any) => {
    loadingRef.value.open()
    groupID.value = item.id
    groupType.value = item.groupType
    gameList.value = [];
    activeItem.value = item.id
    pageNumber.value = 1
    loadedGameCount.value = 0
    if (item.id == 'fav') {
        gameList.value = favoriteGameList.value
        gameCount.value = gameList.value.length
        loadingRef.value.close()
    } else {
        getGameGroupList()
    }
    showPopover.value = false
}
const loadMoreGame = () => {
    loading.value = true
    pageNumber.value++
    if (loadedGameCount.value < gameCount.value) {
        getGameGroupList()
    }
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const getGameGroupList = () => {
    let params = {
        pageNum: pageNumber.value,
        pageSize: PAGE_SIZE,
        groupId: groupID.value,
        groupType: groupType.value
    }
    groupGames(params).then(res => {
        loadingRef.value.close()
        let resData = res.data
        gameCount.value = resData.total
        loadedGameCount.value = loadedGameCount.value + PAGE_SIZE
        loading.value = false
        gameList.value = [...gameList.value, ...resData.rows];
        if (gameCount.value <= loadedGameCount.value) {
            showLoadMore.value = false
        } else {
            showLoadMore.value = true
        }
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
const openRegisterPopup = (type: number) => {
    openRegisterLoginPopup?.(type)
}
const goToDeposit = () => {
    playClickSound()
    router.push(depositButon.value.redirectUrl)
}
const GoToPlayGame = (data: any) => {
    let token = localStorage.getItem('token')
    if (token) {
        router.push({ path: '/pgame', query: { game_type: data.id, game_maker: data.makerId, favorite: data.isFavorite, fav_id:data.favId } })
    } else {
        openRegisterPopup(1)
    }
}


__expose({
    open,
    selectGroup,
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (show.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(GamePopupOne, {
                  "data-set": dataSet.value,
                  onClose: close,
                  onLoadMoreGame: loadMoreGame,
                  onGoToDeposit: goToDeposit,
                  onOpenRegisterPopup: openRegisterPopup,
                  onGoToProfile: goToProfile,
                  onGoToPlayGame: GoToPlayGame,
                  onOpen: open,
                  onSelectGroup: selectGroup
                }, null, 8, ["data-set"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(GamePopupTwo, {
            "data-set": dataSet.value,
            onClose: close,
            onLoadMoreGame: loadMoreGame,
            onGoToDeposit: goToDeposit,
            onOpenRegisterPopup: openRegisterPopup,
            onGoToProfile: goToProfile,
            onGoToPlayGame: GoToPlayGame,
            onOpen: open,
            onSelectGroup: selectGroup
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(GamePopupThree, {
            "data-set": dataSet.value,
            onClose: close,
            onLoadMoreGame: loadMoreGame,
            onGoToDeposit: goToDeposit,
            onOpenRegisterPopup: openRegisterPopup,
            onGoToProfile: goToProfile,
            onGoToPlayGame: GoToPlayGame,
            onOpen: open,
            onSelectGroup: selectGroup
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})